<template src='./TimeLine.html'></template>
<script>
import {filtrosTimeLine,eventosFiltradosTimeLine} from '../../apiService/request/TimeLine'
import formularioOverlay from "../formularioOverlay/formularioOverlay";
import { serverBus } from "../../main";
import { consultarTipoEncuentroSeguimiento} from '../../apiService/request/CrudSeguimiento';
import { consultarMarcacionesProgramasPaciente } from "../../apiService/request/CrudSeguimiento";
import marcacionesPrograma from "../MarcacionesPrograma/marcacionesPrograma";
import { obtenerOpcionesDocumentos, leerUltimosDocumentos, leerDocumentosAsociados } from "../../apiService/request/CrudDocumentos";
import TimeLineDocumentos from "./TimeLineDocumentos/TimeLineDocumentos";
import Icono from "../Icono/Icono";
import TarjetaDescargar  from "../../components/DescargarArchivoV2/TarjetaDescargar/TarjetaDescargar";
import TimeLineTareas from "./TimeLineTareas/TimeLineTareas";
import {tareasPendientesPaciente} from "../../apiService/request/CrudTareasPaciente";

export default {
    data() {
        return {
            cambioTamano:false,
            dx: 0,
            consultaDatosTimeLine: false,
            dialogoDocumentos: false,
            documentosDialogo: [],
            consultandoEnDocumentos: false,
            opcionesDocumentos : null,
            documentosFiltrados: null,
            show: [],
            eventosTimeLine:[],
            filtros:[],
            filtrosSeleccionados:["Encuentros","Seguimientos"],
            cantidaElementosMostrar: 0,
            limite:20,
            on:false,
            dense: true,
            reglasObligatorio: [v => !!v || "Campo obligatorio"],
            componenteKey: 0,
            verComponente: "verEncuentrosSeguimientos",
            coleccion: null,
            overlay: false,
            paciente: {},
            banderaSubirArchivo: false,
            datosMarcacionesPrograma: [],
            item:'',
            iconoDocumentos:"M17,18c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H18C17.4,19,17,18.6,17,18z M30,23H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,23,30,23z M30,29H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,29,30,29z M30,35H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,35,30,35z M38,11l0,31c0,1.1-0.9,2-2,2H8c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h19c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2l10,10c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0.1,0,0.1C38,10.8,38,10.9,38,11C38,11,38,11,38,11z M28,10h6.6L28,3.4V10z M36,42l0-30h-9c-0.6,0-1-0.4-1-1V2H8l0,40L36,42z M14,17h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,17,14,17z M14,23h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,23,14,23z M14,29h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,29,14,29z M14,35h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,35,14,35z M44,0v44 M0,0v44",
            iconoOrdenes:"M43,38H1c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1h42c0.6,0,1,0.4,1,1v30C44,37.6,43.6,38,43,38z M2,36h40V8H2V36z M39,18H15c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1h24c0.6,0,1,0.4,1,1v6C40,17.6,39.6,18,39,18z M16,16h22v-4H16V16z M8,18c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S10.2,18,8,18z M8,12c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S9.1,12,8,12z M40,21c0-0.6-0.4-1-1-1H5c-0.6,0-1,0.4-1,1s0.4,1,1,1h34C39.6,22,40,21.6,40,21z M40,25c0-0.6-0.4-1-1-1H5c-0.6,0-1,0.4-1,1s0.4,1,1,1h34C39.6,26,40,25.6,40,25z M40,29c0-0.6-0.4-1-1-1H19c-0.6,0-1,0.4-1,1s0.4,1,1,1h20C39.6,30,40,29.6,40,29z M40,33c0-0.6-0.4-1-1-1H19c-0.6,0-1,0.4-1,1s0.4,1,1,1h20C39.6,34,40,33.6,40,33z M15,34H5c-0.6,0-1-0.4-1-1v-4c0-0.6,0.4-1,1-1h10c0.6,0,1,0.4,1,1v4C16,33.6,15.6,34,15,34z M6,32h8v-2H6V32z M0,0h44 M44,44H0",
            datosTareasPendientes: {},
            consultandoTareas: true,
        }
    },
    created() {
        this.consultarTareasPendientes();
        // this.consultarOpcionesDocumentos();
        // this.consultarFiltros()
        // this.consultarEventosFiltradosTimeLine()
        // this.consultarMarcacionesProgramas()
    },
     mounted(){
       this.cambiarTamano();
  },
    components: {
        formularioOverlay,
        marcacionesPrograma,
        TimeLineDocumentos,
        Icono,
        TarjetaDescargar,
        TimeLineTareas
    },
    watch: {
        item:function (valor) {
        }
    },
    methods: {
        consultarTimeLine()  {
            this.consultarOpcionesDocumentos();
            this.consultarFiltros()
            this.consultarEventosFiltradosTimeLine()
            this.consultarMarcacionesProgramas()
        },
        cambiarTamano() {
            const BORDER_SIZE = 10;
            let panel = document.getElementById("panelDerecho");
            let tamanoPantalla = screen.width / 2;
            
            let m_pos;
            let resize = e => {
                this.dx = m_pos - e.x;
                m_pos = e.x;
                panel.style.width =
                parseInt(getComputedStyle(panel, "").width) + this.dx + "px";
                this.$store.dispatch("setBarraArrastrar", this.dx);
                this.$emit('cambioTamano',true)
            };
            panel.addEventListener(
                "mousedown",
                e => {
                if (e.offsetX < BORDER_SIZE) {
                    m_pos = e.x;
                    document.addEventListener("mousemove", resize, false);
                }
                },
                false
            );

            document.addEventListener(
                "mouseup",
                function() {
                document.removeEventListener("mousemove", resize, false);
                },
                false
            );
    },

        verDocumentos(documentos) {
            this.documentosDialogo = documentos;
            this.dialogoDocumentos = true;
        },
        salirDialogo() {
            this.documentosDialogo = null;
        },
        async consultarDocumentosFiltrados() {
            try {
                const limite = this.$store.getters.getLimiteConsultaDocumentos; 
                const clases = this.$store.getters.getFiltrosConsultaDocumentos;
                this.consultandoEnDocumentos = true;
                this.consultaDatosTimeLine = true;
                const respuesta = await leerUltimosDocumentos({
                    documento: Number(this.$store.getters.getCedulaPaciente),
                    limite: Number(limite ? limite: 20),
                    clases: (clases && clases.length>= 1) ? clases : null
                });
                if (respuesta && respuesta.data && respuesta.data.data) {
                    this.documentosFiltrados = respuesta.data.data
                }
            } catch (err) {
                this.consultandoEnDocumentos = false;
            } finally {
                this.consultaDatosTimeLine = false;
                this.consultandoEnDocumentos = false;
            }
        },
        async consultarOpcionesDocumentos() {
            try {
                this.consultaDatosTimeLine = true;
                this.consultandoEnDocumentos = true;
                const respuesta = await obtenerOpcionesDocumentos();
                if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.opciones) {
                    this.opcionesDocumentos = respuesta.data.data.opciones;
                }
                this.$store.dispatch("setLimiteConsultaDocumentos", 20);
                this.$store.dispatch("setFiltrosConsultaDocumentos", []);
            } catch (err) {
                this.consultandoEnDocumentos = false;
            } finally {
                this.consultaDatosTimeLine = false;
                this.consultandoEnDocumentos = false;
            }
        },
        async consultarMarcacionesProgramas() {
            try {
                this.consultaDatosTimeLine = true;
                const respuesta = await consultarMarcacionesProgramasPaciente(
                Number(this.$store.getters.getCedulaPaciente)
                );
                this.consultaDatosTimeLine = false;
                this.datosMarcacionesPrograma = respuesta.data.data;
                
            } finally {
            }
        },
        async consultarTareasPendientes(){
            try {
                const response = await tareasPendientesPaciente(Number(this.$store.getters.getCedulaPaciente));
                if (response.data.data) {
                    this.datosTareasPendientes = response.data.data
                }
                
            } catch (error) {
                console.log(error);
            } finally {
                this.consultandoTareas = false
            }
        },
        cerrarTimeLine(){
            this.$router.push('/HistoriaClinica')
            this.$emit('abrirChat')
            this.$emit('tamanoHc')
        },
        cerrarOverlaySinActualizar() {
            this.overlay = false;
        },
        cerrarOverlay(valor) {
            this.overlay = valor;
        },
        async verEncuentro(evento) {
            this.coleccion = evento.coleccion;
            this.$store.dispatch("setVariablesFormulariosOverlay", []);
            this.$store.dispatch("setVariablesActualizadasOverlay", []);
            this.$store.dispatch('setIdVerEncuentrosOSeguimiento', evento.docId);
            this.$store.dispatch('setNombreEventoOverlay', evento.nombre);
            this.$store.dispatch('setColeccionOverlay', evento.coleccion);
            if (evento.coleccion === 'encuentros') {
                this.$store.dispatch('setConsultarEncuentroOverlay', evento.nombre);
            }
            this.overlay = true;
        },
        async consultarTipoEncuentroSeguimientoPaciente(origen, id) {
            try {
                const respuesta = await consultarTipoEncuentroSeguimiento(origen, id);
                if (origen == 'encuentros') {
                this.$store.dispatch('setConsultarEncuentro', respuesta.data.data.key);
                } else if (origen == 'seguimientos') {
                this.$store.dispatch('setNombreEvento', respuesta.data.data.key);
                }
            } finally {
            }
        },
        forceRerender() {
            this.componenteKey += 1;
        },
        mostrarTarjeta(i){
            this.show[i]= !this.show[i]
            this.forceRerender()
        },
        async consultarFiltros(){
            try{
                this.filtros= (await filtrosTimeLine()).data.data
            }
            finally{

            }
        },
        async consultarEventosFiltradosTimeLine(){
            try{
                this.consultaDatosTimeLine = true;
                const respuesta = await eventosFiltradosTimeLine(this.filtrosSeleccionados,Number(this.$store.getters.getCedulaPaciente), this.limite);
                this.eventosTimeLine= respuesta.data.data
                this.eventosTimeLine.map(elemento=>this.show.push(false))
            } catch (err) {
                console.log(err)
            }
            finally{
                this.consultaDatosTimeLine = false;
            }
        },
        calcularCantidadSeleccionada(arrayValores) {
            let maximaLongitud = 0;
            arrayValores.map(variable => {
                if (variable.length >= maximaLongitud) {
                    maximaLongitud = variable.length;
                    if (maximaLongitud >= 7) {
                        this.cantidaElementosMostrar = 0;
                    } else if (maximaLongitud >= 4 && maximaLongitud < 7) {
                        this.cantidaElementosMostrar = 1;
                    } else {
                        this.cantidaElementosMostrar = 2;
                    }
                }
            });
            return arrayValores;
        },
    }

}

</script>
<style lang="scss" scoped src='./TimeLine.scss'></style>


// WEBPACK FOOTER //
// src/components/TimeLine/TimeLine.vue